"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("..");
var __2 = require("../../../..");
var components_1 = require("../../components");
var Label_1 = __importDefault(require("../../components/Label"));
var Form_1 = __importDefault(require("../../Form"));
var SelectTypOsobyUkonu_1 = __importDefault(require("../ZadavatelField/components/SelectTypOsobyUkonu"));
var PridatZadavateleField_1 = require("../ZadavatelField/PridatZadavateleField");
var SelectRoleSpolupracujiciOsobyUkonu_1 = __importDefault(require("./components/SelectRoleSpolupracujiciOsobyUkonu"));
var SpolupracujiciOsoba_1 = __importDefault(require("./components/SpolupracujiciOsoba"));
var BorderDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var $hasError = _a.$hasError;
    return $hasError && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: 50px;\n      padding-top: 12px;\n      padding-left: 2px;\n    "], ["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: 50px;\n      padding-top: 12px;\n      padding-left: 2px;\n    "])));
});
var StyledLabel = styled_components_1.default(function (props) { return react_1.default.createElement(Label_1.default, __assign({}, props)); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: flex-start;\n"], ["\n  align-self: flex-start;\n"])));
var StyledPopup = styled_components_1.default(function (props) { return react_1.default.createElement(__2.Popup, __assign({}, props)); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &-content {\n    padding: 2em 0 0 0;\n  }\n"], ["\n  &-content {\n    padding: 2em 0 0 0;\n  }\n"])));
var FlexColumn = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var StyledDiv = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 6px 0 20px 0;\n"], ["\n  margin: 6px 0 20px 0;\n"])));
var CenteredDiv = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"])));
var PopupDiv = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  max-height: 70vh;\n  overflow: auto;\n"], ["\n  max-height: 70vh;\n  overflow: auto;\n"])));
var prepareValues = function (formResult) {
    var newValue = {};
    newValue.id = formResult.id;
    if (formResult.typOsoby === __2.UkonyTypOsoby.FyzickaOsoba) {
        newValue.jmeno = formResult.jmeno;
        newValue.prijmeni = formResult.prijmeni;
        newValue.datumNarozeni = formResult.datumNarozeni;
        newValue.adresaPobytu = formResult.adresaPobytu;
        newValue.typOsoby = formResult.typOsoby;
        newValue.role = formResult.role;
        if (formResult.titulPred)
            newValue.titulPred = formResult.titulPred;
        if (formResult.titulZa)
            newValue.titulZa = formResult.titulZa;
    }
    if (formResult.typOsoby === __2.UkonyTypOsoby.FyzickaOsobaPodnikajici) {
        newValue.jmeno = formResult.jmeno;
        newValue.prijmeni = formResult.prijmeni;
        newValue.ico = formResult.ico.toString();
        newValue.adresaSidla = formResult.adresaSidla;
        newValue.typOsoby = formResult.typOsoby;
        newValue.role = formResult.role;
        if (formResult.titulPred)
            newValue.titulPred = formResult.titulPred;
        if (formResult.titulZa)
            newValue.titulZa = formResult.titulZa;
    }
    if (formResult.typOsoby === __2.UkonyTypOsoby.PravnickaOsoba) {
        newValue.nazev = formResult.nazev;
        newValue.ico = formResult.ico.toString();
        newValue.adresaSidla = formResult.adresaSidla;
        newValue.typOsoby = formResult.typOsoby;
        newValue.role = formResult.role;
    }
    if (formResult.role === __2.UkonyRoleOsoby.Konzultant) {
        newValue.zvlastniDilciOtazky = formResult.zvlastniDilciOtazky;
        newValue.duvodKPribrani = formResult.duvodKPribrani;
    }
    newValue.role = { id: formResult.role };
    newValue.druh = { id: formResult.typOsoby };
    return newValue;
};
var validate = function (values) {
    var jmenoLens = ramda_1.lensPath(['jmeno']);
    var prijmenilLens = ramda_1.lensPath(['prijmeni']);
    var narozeniLens = ramda_1.lensPath(['datumNarozeni']);
    var adresaPobytuLens = ramda_1.lensPath(['adresaPobytu']);
    var icoLens = ramda_1.lensPath(['ico']);
    var adresaSidlaLens = ramda_1.lensPath(['adresaSidla']);
    var nazevLens = ramda_1.lensPath(['nazev']);
    var druhLens = ramda_1.lensPath(['typOsoby']);
    var roleLens = ramda_1.lensPath(['role']);
    var otazkyLens = ramda_1.lensPath(['zvlastniDilciOtazky']);
    var duvodyLens = ramda_1.lensPath(['duvodKPribrani']);
    if (!ramda_1.view(druhLens, values)) {
        return ramda_1.pipe(ramda_1.set(druhLens, 'Typ osoby nebyl vybrán.'))({});
    }
    if (!ramda_1.view(roleLens, values)) {
        return ramda_1.pipe(ramda_1.set(roleLens, 'Role nebyla vybrána.'))({});
    }
    if (ramda_1.view(roleLens, values) === __2.UkonyRoleOsoby.Konzultant) {
        if (!ramda_1.view(otazkyLens, values) || !ramda_1.view(duvodyLens, values)) {
            var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(otazkyLens, values); }, ramda_1.set(otazkyLens, 'Zvláštní dílčí otázky jsou povinné')), ramda_1.when(function () { return !ramda_1.view(duvodyLens, values); }, ramda_1.set(duvodyLens, 'Důvody k přibrání jsou povinné')))({});
            return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
        }
    }
    if (ramda_1.view(druhLens, values) === __2.UkonyTypOsoby.FyzickaOsoba) {
        var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(jmenoLens, values); }, ramda_1.set(jmenoLens, 'Jméno je povinné')), ramda_1.when(function () { return !ramda_1.view(prijmenilLens, values); }, ramda_1.set(prijmenilLens, 'Příjmení je povinné')), ramda_1.when(function () { return !ramda_1.view(narozeniLens, values); }, ramda_1.set(narozeniLens, 'Datum narození je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaPobytuLens, values); }, ramda_1.set(adresaPobytuLens, 'Adresa pobytu je povinná')))({});
        return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
    }
    if (ramda_1.view(druhLens, values) === __2.UkonyTypOsoby.FyzickaOsobaPodnikajici) {
        var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(jmenoLens, values); }, ramda_1.set(jmenoLens, 'Jméno je povinné')), ramda_1.when(function () { return !ramda_1.view(prijmenilLens, values); }, ramda_1.set(prijmenilLens, 'Příjmení je povinné')), ramda_1.when(function () { return !ramda_1.view(icoLens, values); }, ramda_1.set(icoLens, 'IČO je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaSidlaLens, values); }, ramda_1.set(adresaSidlaLens, 'Adresa sídla je povinná')))({});
        return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
    }
    if (ramda_1.view(druhLens, values) === __2.UkonyTypOsoby.PravnickaOsoba) {
        var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(nazevLens, values); }, ramda_1.set(nazevLens, 'Název je povinný')), ramda_1.when(function () { return !ramda_1.view(icoLens, values); }, ramda_1.set(icoLens, 'IČO je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaSidlaLens, values); }, ramda_1.set(adresaSidlaLens, 'Adresa sídla je povinná')))({});
        return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
    }
};
var PridatSpolupracujiciOsobuUkonuField = function (_a) {
    var name = _a.name, label = _a.label, readOnly = _a.readOnly;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var isOpen = __2.useBoolean(false);
    var adresaPlaceHolder = '';
    var value = field.value || [];
    var _c = react_1.useState(undefined), indexToEdit = _c[0], setIndexToEdit = _c[1];
    var _d = react_1.useState(), valueToEdit = _d[0], setValueToEdit = _d[1];
    var role = __2.useCiselnik('ukonyRole').data;
    var druhyOsoby = __2.useCiselnik('ukonyDruhyOsob').data;
    var FyzickaOsobaForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul p\u0159ed jm\u00E9nem", name: "titulPred" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul za jm\u00E9nem", name: "titulZa" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Jm\u00E9no, p\u0159\u00EDpadn\u011B jm\u00E9na", name: "jmeno" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "P\u0159\u00EDjmen\u00ED", name: "prijmeni" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa bydli\u0161t\u011B", name: "adresaPobytu", placeholder: adresaPlaceHolder }),
            react_1.default.createElement(__1.DateFieldLabeled, { label: "Datum narozen\u00ED", name: "datumNarozeni", maxDate: new Date() }))));
    var FyzickaOsobaPodnikajiciForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul p\u0159ed jm\u00E9nem", name: "titulPred" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul za jm\u00E9nem", name: "titulZa" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Jm\u00E9no, p\u0159\u00EDpadn\u011B jm\u00E9na", name: "jmeno" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "P\u0159\u00EDjmen\u00ED", name: "prijmeni" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(FlexColumn, null,
                react_1.default.createElement(PridatZadavateleField_1.MarginLabel, { htmlFor: "ico" }, "I\u010CO"),
                react_1.default.createElement(__1.IcoField, { name: "ico" })),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa s\u00EDdla", name: "adresaSidla", placeholder: adresaPlaceHolder }))));
    var PravnickaOsobaForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "N\u00E1zev", name: "nazev" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(FlexColumn, null,
                react_1.default.createElement(PridatZadavateleField_1.MarginLabel, { htmlFor: "ico" }, "I\u010CO"),
                react_1.default.createElement(__1.IcoField, { name: "ico" })),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa s\u00EDdla", name: "adresaSidla", placeholder: adresaPlaceHolder }))));
    var getForm = function (druh) {
        if (druh === __2.UkonyTypOsoby.FyzickaOsobaPodnikajici)
            return FyzickaOsobaPodnikajiciForm;
        if (druh === __2.UkonyTypOsoby.PravnickaOsoba)
            return PravnickaOsobaForm;
        return FyzickaOsobaForm;
    };
    var activateEditMode = function (i) { return __awaiter(void 0, void 0, void 0, function () {
        var updateValue;
        return __generator(this, function (_a) {
            setIndexToEdit(i);
            updateValue = value[i];
            setValueToEdit(updateValue);
            isOpen.setTrue();
            return [2 /*return*/];
        });
    }); };
    var deactivatePopup = function () {
        setIndexToEdit(undefined);
        setValueToEdit(undefined);
        isOpen.setFalse();
    };
    var handleSubmit = function (formResult, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var newValues;
        return __generator(this, function (_a) {
            try {
                formikHelpers.setStatus(undefined);
                if (indexToEdit !== undefined) {
                    helpers.setValue(ramda_1.set(ramda_1.lensIndex(indexToEdit), prepareValues(formResult), value));
                }
                else {
                    newValues = prepareValues(formResult);
                    helpers.setValue(__spreadArrays(value, [newValues]));
                }
                isOpen.setFalse();
                setIndexToEdit(undefined);
                setValueToEdit(undefined);
                return [2 /*return*/];
            }
            catch (e) {
                formikHelpers.setStatus({ type: 'error', message: e.message });
            }
            return [2 /*return*/];
        });
    }); };
    var handleDeleteSpolupracujiciOsoba = function (i) {
        var toRemove = value[i];
        var filtered = value.filter(function (po) { return po !== toRemove; });
        helpers.setValue(filtered);
    };
    return (react_1.default.createElement(components_1.Field, { topAlign: true },
        (value === null || value === void 0 ? void 0 : value.length) ? react_1.default.createElement(StyledLabel, { htmlFor: name }, label) : react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(BorderDiv, { "$hasError": !!meta.error && !value },
            !!(value === null || value === void 0 ? void 0 : value.length) && (react_1.default.createElement(react_1.default.Fragment, null, value === null || value === void 0 ? void 0 : value.map(function (item, i) { return (react_1.default.createElement(SpolupracujiciOsoba_1.default, { item: item, index: i, onEdit: activateEditMode, onDelete: handleDeleteSpolupracujiciOsoba, role: role, readOnly: readOnly })); }))),
            react_1.default.createElement(__2.LinkButton, { type: "button", className: "button", onClick: isOpen.toggle, disabled: readOnly }, "P\u0159idat osoby"),
            react_1.default.createElement(StyledPopup, { open: isOpen.value, onClose: deactivatePopup },
                react_1.default.createElement(PridatZadavateleField_1.Title, null,
                    indexToEdit !== undefined ? 'Upravit' : 'Přidat',
                    " spolupracuj\u00EDc\u00ED osobu"),
                react_1.default.createElement(Form_1.default, { initialValues: valueToEdit ? __assign(__assign({}, valueToEdit), { role: valueToEdit.role.id, typOsoby: valueToEdit.druh.id }) : {}, onSubmit: handleSubmit, validate: validate }, function (_a) {
                    var isSubmitting = _a.isSubmitting, values = _a.values;
                    return (react_1.default.createElement(PopupDiv, null,
                        react_1.default.createElement(__2.Padder, null,
                            react_1.default.createElement(Label_1.default, null, "Typ osoby"),
                            react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
                                react_1.default.createElement(StyledDiv, null,
                                    react_1.default.createElement(SelectTypOsobyUkonu_1.default, { name: "typOsoby", filterResult: function (_a) {
                                            var id = _a.id;
                                            return id !== __2.UkonyTypOsoby.OVM;
                                        } }))),
                            getForm(values.typOsoby),
                            react_1.default.createElement(Label_1.default, null, "Role"),
                            react_1.default.createElement(StyledDiv, null,
                                react_1.default.createElement(SelectRoleSpolupracujiciOsobyUkonu_1.default, { name: "role", filterResult: function (r) { return r.id === __2.UkonyRoleOsoby.Konzultant || r.id === __2.UkonyRoleOsoby.DalsiOsoba || r.id === __2.UkonyRoleOsoby.OsobaPosuzujiciZvlastniOtazky; } })),
                            values.role === __2.UkonyRoleOsoby.Konzultant && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(StyledDiv, null,
                                    react_1.default.createElement(__1.TextAreaField, { label: "Zvl\u00E1\u0161tn\u00ED d\u00EDl\u010D\u00ED ot\u00E1zky", name: "zvlastniDilciOtazky" })),
                                react_1.default.createElement(StyledDiv, null,
                                    react_1.default.createElement(__1.TextAreaField, { label: "D\u016Fvody k p\u0159ibr\u00E1n\u00ED", name: "duvodKPribrani" })))),
                            react_1.default.createElement(CenteredDiv, null,
                                react_1.default.createElement(__2.Button, { type: "submit", primary: true, loading: isSubmitting, name: "pridatSpolupracujiciOsobu" }, indexToEdit !== undefined ? 'ULOŽIT ZMĚNY' : 'PŘIDAT OSOBU')))));
                })))));
};
PridatSpolupracujiciOsobuUkonuField.defaultProps = {
    readOnly: undefined,
};
exports.default = PridatSpolupracujiciOsobuUkonuField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
